export default {
  methods: {
    createOrderCommonSense (orderPrice, receivedPrice, callbackFunc) {
      // 检验规则
      const MIN_PRICE = 50 // 下限金额
      const MAX_PRICE = 100000 // 上限金额
      if (receivedPrice > MIN_PRICE && receivedPrice < MAX_PRICE) {
        callbackFunc && callbackFunc(true)
        return
      } 

      // 生成common sense Modal
      const config = {
        content: `当前订单总价为${orderPrice}元，实付金额为${receivedPrice}元，继续操作？`,
        confirmFunc: callbackFunc
      }
      this.displayCommonSenseModal(config)
    },
    /**
     * confirm modal
     * @param {Object} config 配置
     * @param {String, Number} config.content modal内容
     * @param {Function} config.confirmFunc 确认回调函数
     * @param {Function} config.cancelFunc 取消回调函数
     */
    displayCommonSenseModal (config = {}) {
      const modalConfig = {
        content: config.content || '',
        onOk: () => {
          config.confirmFunc && config.confirmFunc(true)
        },
        onCancel: () => {
          config.cancelFunc && config.cancelFunc(false)
        }
      }

      this.$Modal.confirm(modalConfig)
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/common-sense.js